<template>
  <fragment>
   
        <v-flex md3 xs12 >
          <v-select v-if="$store.state.userCompanies.length > 1 && !demoMode"
            :items="filteredCompanies"
            :item-color="companyPrimaryColor"
            :background-color="$vuetify.theme.themes[theme].menu"
            item-text="name"
            item-value="id"
            v-on:input="selectCompany"
            :value="$store.state.activeCompanyData.id"
            no-data-text="Geen aansluiting gevonden."
            label="Selecteer aansluiting"
            outlined
            hide-details
            dense
            :loading="companyLoading"
            :disabled="companyLoading"
            >
            <template v-slot:prepend-item>
              <v-list-item>
                <v-list-item-content  class="pt-0" >
                  <v-text-field
                    :color="companyPrimaryColor"
                    placeholder="Zoeken"
                    prepend-inner-icon="search"
                    clearable
                    background-color="background"
                    outlined
                    v-model="searchCompanies"
                    hide-details
                    dense
                  ></v-text-field>
                </v-list-item-content>
              </v-list-item>
              <v-divider></v-divider>
              <div v-if="searchCompanies && searchCompanies.length > 0" style="padding: 4px 17px 3px 17px; background-color:rgba(0,0,0, 0.02); color: rgba(0, 0, 0, 0.6); text-align: center; font-size: 12px">{{ filteredCompanies.length }} van {{ $store.state.userCompanies.length }} aansluitingen</div>
              <v-divider v-if="searchCompanies && searchCompanies.length > 0"></v-divider>
            </template>
          </v-select>
        </v-flex>
        <v-flex md3 xs12 >
          <v-select 
          v-if="$store.state.userBranches.length > 1 && !demoMode" 
            :loading="branchLoading || companyLoading"
            :disabled="branchLoading || companyLoading"
            :items="$store.state.userBranches"
            v-on:input="selectBranch"
            :item-color="companyPrimaryColor"
            :background-color="$vuetify.theme.themes[theme].menu"
            item-text="name"
            item-value="id"
            :value="$store.state.activeBranchData.id"
            label="Selecteer locatie"
            outlined
            hide-details
            dense
          >
          </v-select>
        </v-flex>
      </fragment>
</template>


<script>
export default {
  name: "CompanySelector",
  data: () => ({
    searchCompanies: "",
    companyLoading: false,
    branchLoading: false
  }),
  props: {
    loading: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  methods: {
    logout() {
      this.$store.dispatch("userLogout");
    },

    async selectCompany(id){
      this.companyLoading = true;
      await this.$store.dispatch("selectCompany", id);
      this.$emit("dataChanged");
      this.companyLoading = false;
    },

    async selectBranch(id){
      this.branchLoading = true;
      await this.$store.dispatch("selectBranch", id);
      this.$emit("dataChanged");
      this.branchLoading = false;
    }
  },

  computed: {
    filteredCompanies(){
      return this.$store.state.userCompanies.filter(company => {
        return company.name.toLowerCase().includes(this.searchCompanies.toLowerCase());
      });
    },

    demoMode(){
      return this.$store.state.demoMode;
    },

    companyPrimaryColor(){
      return this.$store.state.companyPrimaryColor;
    },

    theme(){
      return (this.$vuetify.theme.dark) ? 'dark' : 'light'
    },    
  }
};
</script>
